module.exports = __webpack_public_path__ + "img/brandImg8.b1e87327.jpg";